import styled from 'styled-components';

import Dropdown from 'components/Dropdown';
import { black } from 'utils/style/colors';

const { MenuItem } = Dropdown;

export const ActionMenuButton = styled('a')`
  float: left;
  padding: 0 2px;
  i {
    width: 3.2rem;
  }
`;

export const MenuItemUploadFile = styled(MenuItem)`
  position: relative;
  input[type='file'] {
    cursor: pointer;
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;

export const HeaderContainer = styled.div``;

export const NavHeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${black};
`;

export const NavHeaderItem = styled.li`
  display: flex;
  padding: 0 1rem;
  font-weight: bold;
  line-height: 1.25rem;
`;
